import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class EnvironmentService {
  private apiUrl: string = '';
  private detectionComplete = false;

  async detectBackendUrl(): Promise<void> {
    if (this.detectionComplete) {
      return;
    }

    // � PRODUCTION & TEST: Nutze explizit konfigurierte apiUrl (autoDetect === false)
    if (!environment.autoDetect && environment.apiUrl) {
      this.apiUrl = environment.apiUrl;
      this.detectionComplete = true;
      console.log('[ENVIRONMENT] ✅ Using configured API URL:', this.apiUrl);
      return;
    }

    // 🟢 DEVELOPMENT: Auto-detect localhost (autoDetect === true)
    console.log('[ENVIRONMENT] 🔍 Development Mode: Auto-detecting backend...');

    // Try HTTPS first (7002)
    if (await this.isBackendAvailable('https://localhost:7002')) {
      this.apiUrl = 'https://localhost:7002/api';
      environment.apiUrl = this.apiUrl;
      this.detectionComplete = true;
      console.log('[ENVIRONMENT] ✅ Backend auto-detected on HTTPS (localhost:7002)');
      return;
    }

    // Fallback to HTTP (7001)
    if (await this.isBackendAvailable('http://localhost:7001')) {
      this.apiUrl = 'http://localhost:7001/api';
      environment.apiUrl = this.apiUrl;
      this.detectionComplete = true;
      console.log('[ENVIRONMENT] ⚠️  Backend auto-detected on HTTP (localhost:7001)');
      return;
    }

    // Graceful fallback
    this.apiUrl = 'https://localhost:7002/api';
    environment.apiUrl = this.apiUrl;
    this.detectionComplete = true;
    console.warn(
      '[ENVIRONMENT] ⚠️  Backend not reachable on port 7001 or 7002. ' +
      'Using default HTTPS (localhost:7002). ' +
      'Make sure your backend is running!'
    );
    return;
  }

  private isBackendAvailable(baseUrl: string): Promise<boolean> {
    const serverRoot = baseUrl.replace('/api', '');
    const healthUrl = `${serverRoot}/health`;
    
    return Promise.race([
      fetch(healthUrl, {
        method: 'GET',
        mode: 'no-cors',
      })
        .then(() => true)
        .catch(() => false),
      new Promise<boolean>(resolve => 
        setTimeout(() => resolve(false), 1500)
      )
    ]);
  }

  getApiUrl(): string {
    if (!this.apiUrl) {
      throw new Error(
        'API URL not initialized! Call detectBackendUrl() first.'
      );
    }
    return this.apiUrl;
  }

  setApiUrl(url: string): void {
    this.apiUrl = url;
    environment.apiUrl = url;
    this.detectionComplete = true;
  }
}

